import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AddLocationOutlinedIcon from '@mui/icons-material/AddLocationOutlined';
import CollectionsBookmarkOutlinedIcon from '@mui/icons-material/CollectionsBookmarkOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import PlaceIcon from '@mui/icons-material/Place';
import PeopleIcon from '@mui/icons-material/People';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import CommentIcon from '@mui/icons-material/Comment';
import ManageAccountsSharpIcon from '@mui/icons-material/ManageAccountsSharp';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SouthAmericaIcon from '@mui/icons-material/SouthAmerica';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PaidIcon from '@mui/icons-material/Paid';
import MapIcon from '@mui/icons-material/Map';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import CodeIcon from '@mui/icons-material/Code';
import Assignment from '@mui/icons-material/Assignment';
import Inventory from '@mui/icons-material/Inventory';
import type { SvgIconProps } from '@mui/material';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import GridViewIcon from '@mui/icons-material/GridView';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import ScienceIcon from '@mui/icons-material/Science';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import ChecklistIcon from '@mui/icons-material/Checklist';
// import ReportProblemIcon from '@mui/icons-material/ReportProblem';
// import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

import {
  AssetManagementITSVG,
  ComponentConfigSVG,
  EnginnerITSVG,
  InformativeModuleSVG,
  SuppliesSVG,
  UbicationSVG,
  WarehouseITSVG
} from 'components/shared/Icons';

import { AccessElements, Role } from './app.config';

export type DrawerItem = {
  key: string;
  path?: string;
  title: string | JSX.Element;
  disabled?: boolean;
  icon: SvgIconProps;
  roles?: Role[];
  submenu?: DrawerItem[];
  permissions?: AccessElements[];
  activeSubMenu?: boolean;
  url?: string;
};

/**
 * drawerConfig helper
 *
 * This configuration defines the structure and properties of the drawer items used in the application.
 * Each item includes properties such as key, path, title, icon, roles, permissions, and submenu.
 *
 * @returns {DrawerItem[]} An array of drawer items with their properties.
 */
const drawerConfig: DrawerItem[] = [
  {
    key: 'drawer.componentConfig.componentConfigTitle',
    title: 'Componente configuración',
    path: `/`,
    icon: <ComponentConfigSVG />,
    roles: [Role.ADM, Role.DIS],
    permissions: [
      AccessElements.ProductSearchGeneral,
      AccessElements.ProductBulkLoad,
      AccessElements.ProductMap
    ],
    submenu: [
      {
        key: 'drawer.componentConfig.componentConfigCatalog',
        path: `/configurationComponent`,
        title: 'Componente de configuración',
        icon: <AddLocationOutlinedIcon />,
        roles: [Role.ADM, Role.DIS],
        permissions: [AccessElements.ProductSearchGeneral]
      },
      {
        key: 'drawer.componentConfig.configurationComponentsMaps',
        path: `/configurationComponent/Map`,
        title: 'Mapa de componentes de configuración',
        icon: <MapIcon />,
        roles: [Role.ADM, Role.DIS],
        permissions: [AccessElements.ProductMap]
      },
      {
        key: 'drawer.componentConfig.massiveLoad',
        path: `/configurationComponent/massiveLoad`,
        title: 'Carga masiva de componentes de configuración',
        icon: <UploadFileIcon />,
        roles: [Role.ADM, Role.DIS],
        permissions: [AccessElements.ProductBulkLoad]
      },
      {
        key: 'drawer.componentConfig.massiveUpdate',
        path: `/configurationComponent/massiveUpdate`,
        title: 'Actualización masiva de componentes de configuración',
        icon: <UploadFileIcon />,
        roles: [Role.ADM, Role.DIS],
        permissions: [AccessElements.ProductBulkLoad]
      }
    ]
  },
  /*
  {
    key: 'drawer.solutions.drawerTitle',
    title: 'Soluciones',
    path: ``,
    icon: <EmojiObjectsIcon />,
    roles: [],
    permissions: [],
    submenu: [
      {
        key: 'drawer.solutions.solutionsSearch',
        path: `/solutions/find`,
        title: 'Componente de configuración',
        icon: <ManageSearchIcon />,
        roles: [],
        permissions: []
      },
      {
        key: 'drawer.solutions.newSolution',
        path: `/solutions/create`,
        title: 'Mapa de componentes de configuración',
        icon: <LocalActivityIcon />,
        roles: [],
        permissions: []
      }
    ]
  },
  */
  {
    key: 'drawer.tickets.ticketsTitle',
    title: 'Tickets',
    path: `/`,
    icon: <ConfirmationNumberIcon />,
    roles: [Role.ADM, Role.CWR, Role.CRE, Role.DIS, Role.ENG, Role.SUP],
    permissions: [
      AccessElements.TicketCreate,
      AccessElements.TicketSearchGeneral,
      AccessElements.TicketGetById,
      AccessElements.TicketUpdateToHistoricStatus,
      AccessElements.TicketUpdateToCanceledStatus,
      AccessElements.TicketUpdateToPendingValidationStatus,
      AccessElements.TicketSaveMultiTicket,
      AccessElements.TicketAcceptAssignation,
      AccessElements.TicketRejectAssignation,
      AccessElements.TicketUpdateToTravelStatus,
      AccessElements.TicketUpdateToOnSiteStatus,
      AccessElements.TicketUpdateToClosedStatus,
      AccessElements.TicketUpdateToQuickRecoverStatus,
      AccessElements.TicketUpdateToPendingReasonStatus,
      AccessElements.TicketReplication,
      AccessElements.TicketSearchHistorical,
      AccessElements.TicketSearchCanceled,
      AccessElements.TicketAssignation,
      AccessElements.TicketReject,
      AccessElements.TicketReAssignation,
      AccessElements.TicketAddComment,
      AccessElements.TicketAddFile,
      AccessElements.TicketCancelODT,
      AccessElements.TicketCreateODT,
      AccessElements.TicketDeleteFile,
      AccessElements.TicketDownloadFile,
      AccessElements.TicketQueryComment,
      AccessElements.TicketQueryFile,
      AccessElements.TicketQueryODTDetail,
      AccessElements.TicketSearchODT,
      AccessElements.TicketSearchProgrammed,
      AccessElements.TicketSaveMultiTicket
    ],
    submenu: [
      {
        key: 'drawer.tickets.crudTicket',
        path: `/requirement/createTicket/incident`,
        title: 'Nuevo Ticket Incidente',
        icon: <LocalActivityIcon />,
        roles: [Role.ADM, Role.CWR, Role.DIS, Role.SUP],
        permissions: [AccessElements.TicketCreate]
      },
      {
        key: 'drawer.tickets.createTicketService',
        path: `/requirement/createTicket/service`,
        title: 'Nuevo Ticket Servicio',
        icon: <LocalActivityIcon />,
        roles: [Role.ADM, Role.CWR, Role.DIS, Role.SUP],
        permissions: [AccessElements.TicketCreate]
      },
      {
        key: 'drawer.tickets.findWorkForce',
        path: `/requirement/find`,
        title: 'Búsqueda de Ticket',
        icon: <ManageSearchIcon />,
        roles: [Role.ENG],
        permissions: [
          AccessElements.TicketSearchGeneral,
          AccessElements.TicketCreate,
          AccessElements.TicketAcceptAssignation,
          AccessElements.TicketRejectAssignation,
          AccessElements.TicketUpdateToCanceledStatus,
          AccessElements.TicketUpdateToClosedStatus,
          AccessElements.TicketUpdateToTravelStatus,
          AccessElements.TicketUpdateToOnSiteStatus,
          AccessElements.TicketUpdateToQuickRecoverStatus,
          AccessElements.TicketUpdateToHistoricStatus,
          AccessElements.TicketUpdateToPendingValidationStatus,
          AccessElements.TicketUpdateToPendingReasonStatus,
          AccessElements.TicketUpdateToScheduled
        ]
      },
      {
        key: 'drawer.tickets.bulkLoad',
        path: `/massiveLoad/ExternalFile`,
        title: 'Carga masiva de Tickets',
        icon: <AdminPanelSettingsIcon />,
        roles: [Role.ADM, Role.SUP, Role.DIS],
        permissions: [AccessElements.TicketSaveMultiTicket]
      },
      {
        key: 'drawer.tickets.odtCreate',
        path: `/requirement/odt/create`,
        title: 'Nuevo Servicio Habilitante',
        icon: <ManageSearchIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.TicketCreateODT]
      },
      {
        key: 'drawer.tickets.odtSearch',
        path: `/requirement/odt/search`,
        title: 'Búsqueda servicio habilitante',
        icon: <ManageSearchIcon />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.TicketSearchODT,
          AccessElements.TicketCreateODT,
          AccessElements.TicketCancelODT,
          AccessElements.TicketQueryODTDetail
        ]
      }
    ]
  },
  /*
  {
    key: 'drawer.change.changeTitle',
    path: `/`,
    title: 'Cambios',
    icon: <ConfirmationNumberIcon />,
    roles: [Role.WAD, Role.ENG, Role.ADM],
    permissions: [
      AccessElements.ChangeCreate,
      AccessElements.ChangeSearch,
      AccessElements.ChangeDelete,
      AccessElements.ChangeUpdate
    ],
    submenu: [
      {
        key: 'drawer.change.createChange',
        path: `/change/create`,
        title: 'Nuevo Cambio',
        icon: <LocalActivityIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.ChangeCreate]
      },
      {
        key: 'drawer.change.searchChange',
        path: `/change/find`,
        title: 'Busqueda de Cambio',
        icon: <LocalActivityIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.ChangeSearch]
      }
    ]
  },
  */
  {
    key: 'drawer.shipping.shippingTitle',
    path: `/`,
    title: 'Envíos',
    icon: <LocalShippingIcon />,
    roles: [Role.WAD, Role.ENG, Role.ADM],
    permissions: [
      AccessElements.ShipmentSearchGeneral,
      AccessElements.ShipmentCreate,
      AccessElements.ShipmentUpdate,
      AccessElements.AssetsStateChange,
      AccessElements.ShipmentDelete
    ],
    submenu: [
      {
        key: 'drawer.shipping.crudTicket',
        path: `/shipping/create`,
        title: 'Nuevo Envío',
        icon: <LocalActivityIcon />,
        roles: [Role.ENG, Role.WAD, Role.ADM],
        permissions: [AccessElements.ShipmentCreate]
      },
      {
        key: 'drawer.shipping.findTicket',
        path: `/shipping/find`,
        title: 'Búsqueda de Envío',
        icon: <ManageSearchIcon />,
        roles: [Role.ENG, Role.WAD, Role.ADM],
        permissions: [
          AccessElements.ShipmentSearchGeneral,
          AccessElements.ShipmentCreate,
          AccessElements.ShipmentUpdate,
          AccessElements.AssetsStateChange,
          AccessElements.ShipmentDelete
        ]
      },
      {
        key: 'drawer.shipping.report',
        path: `/shipping/report`,
        title: 'Reporte de Envíos',
        icon: <LocalActivityIcon />,
        roles: [Role.ENG, Role.WAD, Role.ADM],
        permissions: []
      }
    ]
  },
  {
    key: 'drawer.ubications.ubicationsTitle',
    path: `/`,
    title: 'Ubicaciones',
    icon: <UbicationSVG />,
    roles: [Role.ADM],
    permissions: [
      AccessElements.LocationSearch,
      AccessElements.LocationCreate,
      AccessElements.LocationGlobalMap,
      AccessElements.LocationBulkLoad,
      AccessElements.LocationBulkDisable,
      AccessElements.LocationTaskForceGeolocation
    ],
    submenu: [
      {
        key: 'drawer.ubications.list',
        path: `/ubications`,
        title: 'Ubicaciones',
        icon: <PlaceIcon />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.LocationSearch,
          AccessElements.LocationCreate
        ]
      },
      {
        key: 'drawer.ubications.ubicationsMap',
        path: `/ubications/map`,
        title: 'Mapa Ubicaciones',
        icon: <MapIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.LocationGlobalMap]
      },
      {
        key: 'drawer.ubications.ubicationsActivate',
        path: `/ubications/massiveLoadUbications`,
        title: 'Carga masiva de ubicaciones',
        icon: <UploadFileIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.LocationBulkLoad]
      },
      {
        key: 'drawer.ubications.ubicationsDeactivate',
        path: `/ubications/massiveDeactivate`,
        title: 'Inactivar Ubicaciones',
        icon: <ThumbDownAltIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.LocationBulkDisable]
      },
      {
        key: 'drawer.ubications.workForce',
        path: `/ubications/workForce`,
        title: 'Ubicación de fuerza de trabajo',
        icon: <ThumbDownAltIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.LocationTaskForceGeolocation]
      }
    ]
  },
  {
    key: 'drawer.supplies.suppliesTitle',
    path: ``,
    title: 'Insumos',
    icon: <SuppliesSVG />,
    roles: [Role.ADM],
    permissions: [
      AccessElements.SupplyCreate,

      AccessElements.SupplySearchGeneral,

      AccessElements.SuppliesAdd,
      AccessElements.SuppliesSearch
    ],
    submenu: [
      {
        key: 'drawer.supplies.createSupplies',
        path: `/Supplies`,
        title: 'Alta de Insumo',
        icon: <WarehouseIcon />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.SupplyCreate,
          AccessElements.SupplySearchGeneral
        ]
      },
      {
        key: 'drawer.supplies.newSupplies',
        path: `/StockSupplies`,
        title: 'Existencia de Insumo',
        icon: <PrecisionManufacturingIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.SuppliesAdd, AccessElements.SuppliesSearch]
      }
    ]
  },
  {
    key: 'drawer.assetManagementIT.assetManagementITTitle',
    title: 'Gestión activos TI',
    icon: <AssetManagementITSVG />,
    roles: [Role.ADM, Role.WAD, Role.SUP, Role.ENG],
    permissions: [
      AccessElements.AssetsWorkForceProductsSearchExport,
      AccessElements.AssetsSuppliesSearchExport,
      AccessElements.AssetsKitsSearchExport,
      AccessElements.AssetsWarehouseProductsSearchExport,
      AccessElements.AssetsWorkForceSuppliesSearchExport,
      AccessElements.AssetsWarehouseKitsSearchExport,
      AccessElements.AssetsLaboratoryProductsSearchExport
    ],
    submenu: [
      {
        key: 'drawer.assetManagementIT.warehouse.warehouseTitle',
        path: ``,
        title: 'Almacén',
        icon: <WarehouseITSVG />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.AssetsWarehouseProductsSearchExport,
          AccessElements.AssetsSuppliesSearchExport,
          AccessElements.AssetsKitsSearchExport
        ],
        submenu: [
          {
            key: 'drawer.assetManagementIT.warehouse.warehousesComponentInventory',
            path: `/warehousesComponentInventory`,
            title: 'Componentes de Configuración',
            activeSubMenu: true,
            icon: <GridViewIcon />,
            permissions: [AccessElements.AssetsWarehouseProductsSearchExport]
          },
          {
            key: 'drawer.assetManagementIT.warehouse.warehousesSupplyInventory',
            path: `/warehousesSupplyInventory`,
            title: 'Insumos',
            activeSubMenu: true,
            icon: <Inventory2Icon />,
            permissions: [AccessElements.AssetsSuppliesSearchExport]
          },
          {
            key: 'drawer.assetManagementIT.warehouse.kitsWarehouse',
            path: `/kitsWarehouse`,
            title: 'KITS',
            activeSubMenu: true,
            icon: <WarehouseIcon />,
            permissions: [AccessElements.AssetsKitsSearchExport]
          }
        ]
      },
      {
        key: 'drawer.assetManagementIT.laboratory.laboratoryTitle',
        path: ``,
        title: 'Laboratorio',
        icon: <ScienceIcon />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.AssetsLaboratoryProductsSearchExport,
          AccessElements.LaboratoryAceptAndRejectProducts
        ],
        submenu: [
          {
            key: 'drawer.assetManagementIT.laboratory.componentInventory',
            path: `/laboratoryComponentInventory`,
            title: 'Componentes de Configuración',
            activeSubMenu: true,
            icon: <GridViewIcon />,
            permissions: [AccessElements.AssetsLaboratoryProductsSearchExport]
          },
          {
            key: 'drawer.assetManagementIT.laboratory.bulkReception',
            path: `/laboratory/bulkReception`,
            title: 'Recepción masiva',
            activeSubMenu: true,
            icon: null,
            permissions: [AccessElements.LaboratoryAceptAndRejectProducts]
          }
        ]
      },
      {
        key: 'drawer.assetManagementIT.workForce.workForceTitle',
        title: 'Fuerza de Trabajo',
        icon: <EnginnerITSVG />,
        permissions: [
          AccessElements.AssetsWorkForceProductsSearchExport,
          AccessElements.AssetsWorkForceSuppliesSearchExport,
          AccessElements.AssetsWarehouseKitsSearchExport
        ],
        submenu: [
          {
            key: 'drawer.assetManagementIT.workForce.configComponent',
            path: '/assetManagementIT/workForce/configComponent/find/',
            title: 'Componentes de Configuración',
            activeSubMenu: true,
            icon: <GridViewIcon />,
            permissions: [AccessElements.AssetsWorkForceProductsSearchExport]
          },
          {
            key: 'drawer.assetManagementIT.workForce.supplies',
            path: '/assetManagementIT/workForce/supplies/find/',
            title: 'Insumos',
            activeSubMenu: true,
            icon: <Inventory2Icon />,
            permissions: [AccessElements.AssetsWorkForceSuppliesSearchExport]
          },
          {
            key: 'drawer.assetManagementIT.workForce.kits',
            path: '/assetManagementIT/workForce/kits/find/',
            title: 'Kits CI',
            activeSubMenu: true,
            icon: <WarehouseIcon />,
            permissions: [AccessElements.AssetsWarehouseKitsSearchExport]
          }
        ]
      },
      {
        key: 'drawer.assetManagementIT.auditReport',
        path: '/assetManagementIT/AuditReport',
        title: 'Auditorías',
        icon: <GridViewIcon />,
        permissions: [AccessElements.AuditReportSearchGeneral]
      }
    ]
  },
  {
    key: 'drawer.kits.kitsTitle',
    title: 'Kits',
    icon: <HomeRepairServiceIcon />,
    roles: [Role.ADM],
    permissions: [
      AccessElements.KitCreate,
      AccessElements.KitDelete,
      AccessElements.KitComponentsUpdate,
      AccessElements.KitQuery,
      AccessElements.KitUpdate,
      AccessElements.KitLog
    ],
    submenu: [
      {
        key: 'drawer.kits.kits',
        path: `/kits`,
        title: 'Kits',
        icon: <HomeRepairServiceIcon />,
        roles: [Role.ADM]
      }
    ]
  },
  {
    key: 'drawer.admin.adminTitle',
    path: `/`,
    title: 'Admin',
    icon: <AdminPanelSettingsIcon />,
    // roles: [Role.ADM, Role.DIS],
    permissions: [
      AccessElements.WarehouseCreate,
      AccessElements.WarehouseSearchGeneral,
      AccessElements.UsersSearchUser,
      AccessElements.UsersCreateUser,
      AccessElements.UsersUpdateUser,
      AccessElements.UsersDeleteUser,
      AccessElements.UsersResetPassword,
      AccessElements.UsersChangePermissions,
      AccessElements.UsersWarehousePermissions,
      AccessElements.UsersClientPermissions,
      AccessElements.UsersTaskforcePermissions,
      AccessElements.UsersServiceTypePermissions,
      AccessElements.UsersCommentTypePermissions,
      AccessElements.UsersOperationsPermissions,
      AccessElements.UsersExportLog,
      AccessElements.UsersViewTrackingLog,
      AccessElements.ServiceSearchIndicator,
      AccessElements.KPIManagement,
      AccessElements.FormsFormManagement,
      AccessElements.UsersExportLog,
      AccessElements.AuditTypeCreate,
      AccessElements.AuditTypeSearchGeneral,
      AccessElements.BrandCreate,
      AccessElements.BrandSearchGeneral,
      AccessElements.CatalogsAddRegion,
      AccessElements.CatalogsAddState,
      AccessElements.CatalogsSearchRegion,
      AccessElements.CatalogsSearchState,
      AccessElements.CurrencyCreate,

      AccessElements.CurrencySearchGeneral,

      AccessElements.EquipmentTypeCreate,

      AccessElements.EquipmentTypeSearch,
      AccessElements.FlowTypeAdd,
      AccessElements.FlowTypeSearch,
      AccessElements.FlowTypeUpdate,
      AccessElements.FrequentFailureCreate,

      AccessElements.FrequentFailureSearchGeneral,

      AccessElements.InterventionCodeAdd,
      AccessElements.InterventionCodeSearch,

      AccessElements.PriorityCreate,

      AccessElements.PrioritySearchGeneral,

      AccessElements.ProductModelCreate,

      AccessElements.ProductModelSearchGeneral,

      AccessElements.ProjectAdd,

      AccessElements.ProjectSearch,

      AccessElements.ReasonCreate,

      AccessElements.ReasonSearchGeneral,

      AccessElements.ResponsibleCreateType,

      AccessElements.ResponsibleSearchGeneral,
      AccessElements.ServiceTypeCreate,

      AccessElements.ServiceTypeSearchGeneral,
      AccessElements.TicketCommentTypeCreate,

      AccessElements.TicketCommentTypeSearchGeneral,

      AccessElements.UnitsMeasurementCreate,

      AccessElements.UnitsMeasurementSearchGeneral,
      AccessElements.UsersCreateProfile,

      AccessElements.UsersSearchProfile,
      AccessElements.WorkingAreaAddResponsible,
      AccessElements.WorkingAreaCreate,
      AccessElements.WorkingAreaSearchGeneral,
      AccessElements.WorkingAreaSearchResponsible,
      AccessElements.WarehouseTypeSearchGeneral,
      AccessElements.WarehouseTypeCreate,

      AccessElements.DashboardCreate,
      AccessElements.DashboardSearchGeneral,
      AccessElements.CatalogShowNotificationCatalog,
      AccessElements.CatalogShowTicketFlow,
      AccessElements.CatalogShowTicketStatus,
      AccessElements.CategoryCreate,
      AccessElements.TicketStatusAdd,
      AccessElements.TicketStatusSearch,
      AccessElements.TowerModelCreate,
      AccessElements.CatalogSearchTowerModel,
      AccessElements.TowerTypeCreate,
      AccessElements.CatalogSearchTowerType,
      AccessElements.TowerPropertyCreate,
      AccessElements.CatalogSearchTowerProperty,
      AccessElements.TagCodeGeneralSearch,
      AccessElements.TagCodeCreate,
      AccessElements.TagCodeMassiveCreate,
      AccessElements.FuelCodeCreate,
      AccessElements.FuelCodeBulkCreate,
      AccessElements.FuelCodeSearchGeneral,
      AccessElements.ExpenseCodeCreate,
      AccessElements.ExpenseCodeBulkCreate,
      AccessElements.ExpenseCodeSearchGeneral,
      AccessElements.CatalogsAddCP,
      AccessElements.CatalogsSearchCP,
      AccessElements.DelayCatalogCreate,
      AccessElements.DelayCatalogSearch,
      AccessElements.CatalogsHolidays,
      AccessElements.ServiceClassCreate,
      AccessElements.ServiceClassSearch,
      AccessElements.ImpactCreate,
      AccessElements.ImpactSearch,
      AccessElements.UrgencyCreate,
      AccessElements.UrgencySearch,
      AccessElements.TicketPriorityCreate,
      AccessElements.TicketPrioritySearch,
      AccessElements.AssignmentPriorityCreate,
      AccessElements.AssignmentPrioritySearch,
      AccessElements.ClientSearchGeneral,
      AccessElements.ClientCreate,
      AccessElements.ClientUpdate,
      AccessElements.ClientDelete,
      AccessElements.ClientAddState,
      AccessElements.ClientEnableService,
      AccessElements.FlowTypeAdd,
      AccessElements.FlowTypeDelete,
      AccessElements.FlowTypeSearch,
      AccessElements.FlowTypeUpdate,
      AccessElements.ClientCreateODT,
      AccessElements.ClientUpdateODT,
      AccessElements.ClientDeleteODT,
      AccessElements.ClientSearchExportODT,
      AccessElements.ServiceCreate,
      AccessElements.ServiceSearchGeneral,
      AccessElements.ServiceUpdate,
      AccessElements.ServiceDelete,
      AccessElements.ServiceConfiguration,
      AccessElements.AuditCreate,
      AccessElements.AuditCreateReport,
      AccessElements.AuditReportSearchGeneral,
      AccessElements.AuditSearchGeneral
    ],
    submenu: [
      {
        key: 'drawer.admin.stores',
        path: `/admin/stores`,
        title: 'Almacenes',
        icon: <WarehouseIcon />,
        roles: [Role.DIS, Role.ADM],
        permissions: [
          AccessElements.WarehouseCreate,
          AccessElements.WarehouseSearchGeneral
        ]
      },
      {
        key: 'drawer.admin.userConfig',
        path: `/admin/CreateAndConfigUser`,
        title: 'Usuarios',
        icon: <PeopleIcon />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.UsersSearchUser,
          AccessElements.UsersCreateUser,
          AccessElements.UsersUpdateUser,
          AccessElements.UsersDeleteUser,
          AccessElements.UsersResetPassword,
          AccessElements.UsersChangePermissions,
          AccessElements.UsersWarehousePermissions,
          AccessElements.UsersClientPermissions,
          AccessElements.UsersTaskforcePermissions,
          AccessElements.UsersServiceTypePermissions,
          AccessElements.UsersCommentTypePermissions,
          AccessElements.UsersOperationsPermissions,
          AccessElements.UsersExportLog
        ]
      },
      {
        key: 'drawer.admin.permissionsAudit',
        path: `/admin/permissionsAudit`,
        title: 'Auditoría de permisos',
        icon: <PeopleIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.UsersViewTrackingLog]
      },
      {
        key: 'drawer.admin.indicators',
        path: '/admin/Indicators',
        title: 'Indicadores',
        icon: <EmojiFlagsIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.ServiceSearchIndicator]
      },
      {
        key: 'KPIs',
        path: '/admin/kpis',
        title: 'KPIs',
        icon: <DonutLargeIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.KPIManagement]
      },
      {
        key: 'drawer.admin.formsManagement',
        path: `/admin/formsManagement`,
        title: 'Gestión de Formularios',
        icon: <ManageAccountsSharpIcon />,
        permissions: [AccessElements.FormsFormManagement]
      },
      {
        key: 'drawer.admin.accessLogbook',
        path: '/admin/AccessLogbook',
        title: 'Bitácora de Accesos',
        icon: <AccessTimeIcon />,
        roles: [Role.ADM],
        permissions: [AccessElements.UsersExportLog]
      },
      /*
      {
        key: 'drawer.tasks.drawerTitle',
        path: '',
        title: 'Catálogo de Estatus',
        icon: <InformativeModuleSVG />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.TaskAddFile,
          AccessElements.TaskDeleteFile,
          AccessElements.TaskDownloadFile,
          AccessElements.TaskQueryFile,
          AccessElements.TaskSearchGeneral,
          AccessElements.TaskCreate,
          AccessElements.TaskGetById,
          AccessElements.TaskUpdate,
          AccessElements.TaskDelete
        ],
        submenu: [
          {
            key: 'admin.statusesOfTasks.drawerName',
            path: `/admin/statusesOfTasks`,
            title: 'Catálogo de Estatus',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [],
            permissions: []
          }
        ]
      },
      */
      {
        key: 'drawer.admin.catalogues.cataloguesTitle',
        path: '',
        title: 'Gestión de Catálogos',
        icon: <CollectionsBookmarkOutlinedIcon />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.AuditTypeCreate,
          AccessElements.AuditTypeSearchGeneral,
          AccessElements.BrandCreate,
          AccessElements.BrandSearchGeneral,
          AccessElements.CatalogsAddRegion,
          AccessElements.CatalogsAddState,
          AccessElements.CatalogsSearchRegion,
          AccessElements.CatalogsSearchState,
          AccessElements.CurrencyCreate,
          AccessElements.CurrencySearchGeneral,
          AccessElements.EquipmentTypeCreate,
          AccessElements.EquipmentTypeSearch,
          AccessElements.FlowTypeAdd,
          AccessElements.FlowTypeSearch,
          AccessElements.FrequentFailureCreate,
          AccessElements.FrequentFailureSearchGeneral,
          AccessElements.InterventionCodeAdd,
          AccessElements.InterventionCodeSearch,
          AccessElements.PriorityCreate,
          AccessElements.PrioritySearchGeneral,
          AccessElements.ProductModelCreate,
          AccessElements.ProductModelSearchGeneral,
          AccessElements.ProjectAdd,
          AccessElements.ProjectSearch,
          AccessElements.ReasonCreate,
          AccessElements.ReasonSearchGeneral,
          AccessElements.ResponsibleCreateType,
          AccessElements.ResponsibleSearchGeneral,
          AccessElements.ServiceTypeCreate,
          AccessElements.ServiceTypeSearchGeneral,
          AccessElements.TicketCommentTypeCreate,
          AccessElements.TicketCommentTypeSearchGeneral,
          AccessElements.UnitsMeasurementCreate,
          AccessElements.UnitsMeasurementSearchGeneral,
          AccessElements.UsersCreateProfile,
          AccessElements.UsersSearchProfile,
          AccessElements.WorkingAreaAddResponsible,
          AccessElements.WorkingAreaCreate,
          AccessElements.WorkingAreaSearchGeneral,
          AccessElements.WorkingAreaSearchResponsible,
          AccessElements.WarehouseTypeSearchGeneral,
          AccessElements.WarehouseTypeCreate,
          AccessElements.DashboardCreate,
          AccessElements.DashboardSearchGeneral,
          AccessElements.CatalogShowNotificationCatalog,
          AccessElements.CatalogShowTicketFlow,
          AccessElements.CatalogShowTicketStatus,
          AccessElements.CategoryCreate,
          AccessElements.TicketStatusAdd,
          AccessElements.TicketStatusSearch,
          AccessElements.TowerModelCreate,
          AccessElements.CatalogSearchTowerModel,
          AccessElements.TowerTypeCreate,
          AccessElements.CatalogSearchTowerType,
          AccessElements.TowerPropertyCreate,
          AccessElements.CatalogSearchTowerProperty,
          AccessElements.TagCodeGeneralSearch,
          AccessElements.TagCodeCreate,
          AccessElements.TagCodeMassiveCreate,
          AccessElements.FuelCodeCreate,
          AccessElements.FuelCodeBulkCreate,
          AccessElements.FuelCodeSearchGeneral,
          AccessElements.ExpenseCodeCreate,
          AccessElements.ExpenseCodeBulkCreate,
          AccessElements.ExpenseCodeSearchGeneral,
          AccessElements.CategorySearch,
          AccessElements.CatalogsAddCP,
          AccessElements.CatalogsSearchCP,
          AccessElements.DelayCatalogCreate,
          AccessElements.DelayCatalogSearch,
          AccessElements.CatalogsHolidays,
          AccessElements.ServiceClassCreate,
          AccessElements.ServiceClassSearch
        ],
        submenu: [
          {
            key: 'drawer.admin.catalogues.invoiceTAG',
            path: `/admin/invoiceTAG`,
            title: 'Folio de TAG (peaje)',
            activeSubMenu: true,
            icon: <PaidIcon />,
            permissions: [
              AccessElements.TagCodeGeneralSearch,
              AccessElements.TagCodeCreate,
              AccessElements.TagCodeMassiveCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.invoiceFuel',
            path: `/admin/invoiceFuel`,
            title: 'Folio de Combustible',
            activeSubMenu: true,
            icon: <PaidIcon />,
            permissions: [
              AccessElements.FuelCodeCreate,
              AccessElements.FuelCodeBulkCreate,
              AccessElements.FuelCodeSearchGeneral
            ]
          },
          {
            key: 'drawer.admin.catalogues.invoiceExpenseCode',
            path: `/admin/expenseCode`,
            title: 'Folio de Viáticos',
            activeSubMenu: true,
            icon: <PaidIcon />,
            permissions: [
              AccessElements.ExpenseCodeCreate,
              AccessElements.ExpenseCodeBulkCreate,
              AccessElements.ExpenseCodeSearchGeneral
            ]
          },
          {
            key: 'drawer.admin.catalogues.category',
            path: `admin/category`,
            title: 'Categoría',
            activeSubMenu: true,
            icon: <EngineeringOutlinedIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.CategoryCreate,
              AccessElements.CategorySearch
            ]
          },
          {
            key: 'drawer.admin.catalogues.currency',
            path: `/admin/currency`,
            title: 'Monedas',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.CurrencySearchGeneral,
              AccessElements.CurrencyCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.reportCatalogue',
            path: `/admin/reportCatalogue`,
            title: 'Reportes',
            activeSubMenu: true,
            icon: <PaidIcon />,
            permissions: [
              AccessElements.DashboardCreate,
              AccessElements.DashboardSearchGeneral
            ]
          },
          {
            key: 'drawer.admin.catalogues.regions',
            path: `/admin/regions`,
            title: 'Regiones',
            activeSubMenu: true,
            icon: <SouthAmericaIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.CatalogsSearchRegion,
              AccessElements.CatalogsAddRegion
            ]
          },
          {
            key: 'drawer.admin.catalogues.states',
            path: `/admin/states`,
            title: 'Estados',
            activeSubMenu: true,
            icon: <FactCheckIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.CatalogsSearchState,
              AccessElements.CatalogsAddState
            ]
          },
          {
            key: 'drawer.admin.catalogues.postalCodes',
            title: 'Códigos Postales',
            path: '/admin/postalCodes',
            permissions: [
              AccessElements.CatalogsAddCP,
              AccessElements.CatalogsSearchCP
            ],
            activeSubMenu: true,
            icon: <FactCheckIcon />
          },
          {
            key: 'drawer.admin.catalogues.area',
            path: `/admin/area`,
            title: 'Área',
            activeSubMenu: true,
            icon: <SensorOccupiedIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.WorkingAreaSearchGeneral,
              AccessElements.WorkingAreaCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.clasifitactionTicket',
            path: `/admin/clasificationTicket`,
            title: 'Clasificación de demoras de ticket',
            activeSubMenu: true,
            icon: <SensorOccupiedIcon />,
            roles: [Role.ADM, Role.DIS, Role.SUP],
            permissions: [
              AccessElements.DelayCatalogCreate,
              AccessElements.DelayCatalogSearch
            ]
          },
          {
            key: 'drawer.admin.catalogues.headOfArea',
            path: `/admin/headOfArea`,
            title: 'Jefe de área',
            activeSubMenu: true,
            icon: <EngineeringIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.WorkingAreaSearchResponsible,
              AccessElements.WorkingAreaAddResponsible
            ]
          },
          {
            key: 'drawer.admin.catalogues.commentTypes',
            path: `/admin/commentTypes`,
            title: 'Tipos de comentario',
            activeSubMenu: true,
            icon: <CommentIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.TicketCommentTypeSearchGeneral,
              AccessElements.TicketCommentTypeCreate
            ]
          },
          {
            key: 'common.commonProperties.towerModel',
            path: `/admin/towerModel`,
            title: 'Modelo de torre',
            activeSubMenu: true,
            icon: <EngineeringOutlinedIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.TowerModelCreate,
              AccessElements.CatalogSearchTowerModel
            ]
          },
          {
            key: 'common.commonProperties.towerType',
            path: `/admin/towerType`,
            title: 'Tipo de torre',
            activeSubMenu: true,
            icon: <EngineeringOutlinedIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.TowerTypeCreate,

              AccessElements.CatalogSearchTowerType
            ]
          },
          {
            key: 'common.commonProperties.towerProperty',
            path: `/admin/towerProperty`,
            title: 'Propiedad',
            activeSubMenu: true,
            icon: <EngineeringOutlinedIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.TowerPropertyCreate,

              AccessElements.CatalogSearchTowerProperty
            ]
          },
          {
            key: 'drawer.admin.catalogues.frecuentlyFailure',
            path: `/admin/frecuentlyFailure`,
            title: 'Tipo de falla',
            activeSubMenu: true,
            icon: <AnnouncementOutlinedIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.FrequentFailureSearchGeneral,
              AccessElements.FrequentFailureCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.serviceType',
            path: `/admin/serviceType`,
            title: 'Tipo de servicio',
            activeSubMenu: true,
            icon: <AdminPanelSettingsIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.ServiceTypeSearchGeneral,
              AccessElements.ServiceTypeCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.ubicationPriority',
            path: `/admin/ubitacionPriority`,
            title: 'Prioridad (de Ubicación)',
            activeSubMenu: true,
            icon: <PriorityHighIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.PrioritySearchGeneral,
              AccessElements.PriorityCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.brand',
            path: `/admin/brand`,
            title: 'Marca',
            activeSubMenu: true,
            icon: <BookmarkIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.BrandSearchGeneral,
              AccessElements.BrandCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.model',
            path: `/admin/model`,
            title: 'Modelo',
            activeSubMenu: true,
            icon: <Inventory />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.ProductModelSearchGeneral,
              AccessElements.ProductModelCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.equipmentType',
            path: `/admin/equipmentType`,
            title: 'Tipo de Equipo',
            activeSubMenu: true,
            icon: <HomeRepairServiceIcon />,
            permissions: [
              AccessElements.EquipmentTypeCreate,

              AccessElements.EquipmentTypeSearch
            ]
          },
          {
            key: 'drawer.admin.catalogues.reasons',
            path: `/admin/reasons`,
            title: 'Motivos',
            activeSubMenu: true,
            icon: <ThumbDownAltIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.ReasonCreate,

              AccessElements.ReasonSearchGeneral
            ]
          },
          {
            key: 'drawer.admin.catalogues.unitsMeasurement',
            path: `/admin/UnitsMeasurement`,
            title: 'Unidades de Medida',
            activeSubMenu: true,
            icon: <ThumbDownAltIcon />,
            permissions: [
              AccessElements.UnitsMeasurementCreate,

              AccessElements.UnitsMeasurementSearchGeneral
            ]
          },
          {
            key: 'drawer.admin.catalogues.warehouseType',
            path: `/admin/WarehouseType`,
            title: 'Tipo de Almacén',
            activeSubMenu: true,
            icon: <ThumbDownAltIcon />,
            permissions: [
              AccessElements.WarehouseTypeSearchGeneral,
              AccessElements.WarehouseTypeCreate
            ]
          },
          {
            key: 'drawer.admin.catalogues.auditCatalog',
            path: `/admin/catalogAudit`,
            title: 'Tipo de auditoría',
            icon: <ThumbDownAltIcon />,
            activeSubMenu: true,
            permissions: [
              AccessElements.AuditTypeCreate,

              AccessElements.AuditTypeSearchGeneral
            ]
          },
          {
            key: 'drawer.admin.catalogues.profiles',
            path: `/admin/profiles`,
            title: 'Perfiles',
            activeSubMenu: true,
            icon: <ManageAccountsSharpIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.UsersSearchProfile,
              AccessElements.UsersCreateProfile
            ]
          },
          {
            key: 'drawer.admin.catalogues.projects',
            path: `/admin/projects`,
            title: 'Proyectos',
            activeSubMenu: true,
            icon: <ManageAccountsSharpIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.ProjectSearch,
              AccessElements.ProjectAdd
            ]
          },
          {
            key: 'drawer.admin.catalogues.workFlowType',
            path: `/admin/workFlowType`,
            title: 'Tipo de flujo de servicio habilitante',
            activeSubMenu: true,
            icon: <ManageAccountsSharpIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.FlowTypeSearch,
              AccessElements.FlowTypeAdd
            ]
          },
          {
            key: 'drawer.admin.catalogues.responsibleType',
            path: `/admin/ResponsibleType`,
            title: 'Tipo Responsable',
            activeSubMenu: true,
            icon: <EngineeringOutlinedIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.ResponsibleSearchGeneral,
              AccessElements.ResponsibleCreateType
            ]
          },
          {
            key: 'drawer.admin.catalogues.interventionCodes',
            path: `admin/interventionCodes`,
            title: 'Códigos de Intervención',
            activeSubMenu: true,
            icon: <CodeIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.InterventionCodeSearch,
              AccessElements.InterventionCodeAdd
            ]
          },
          {
            key: 'drawer.admin.catalogues.calendar',
            path: `/admin/calendar`,
            title: 'Calendarios',
            icon: <CalendarMonthIcon />,
            activeSubMenu: true,
            roles: [Role.ADM],
            permissions: [AccessElements.CatalogsHolidays]
          },
          {
            key: 'drawer.admin.catalogues.notifications',
            path: `/admin/notification`,
            title: 'Notificaciones',
            icon: <CalendarMonthIcon />,
            activeSubMenu: true,
            roles: [Role.ADM],
            permissions: [AccessElements.CatalogShowNotificationCatalog]
          },
          {
            key: 'drawer.admin.catalogues.status',
            path: `admin/status`,
            title: 'Estatus de Tickets',
            icon: <CalendarMonthIcon />,
            activeSubMenu: true,
            roles: [],
            permissions: [
              AccessElements.TicketStatusAdd,

              AccessElements.TicketStatusSearch
            ]
          },
          {
            key: 'drawer.admin.catalogues.flowBoard',
            path: `admin/flowBoard`,
            title: 'Tablero de Flujos',
            icon: null,
            activeSubMenu: true,
            // roles: [Role.ADM],
            permissions: [AccessElements.CatalogShowTicketFlow]
          },
          {
            key: 'drawer.admin.catalogues.serviceClass',
            path: `admin/serviceClass`,
            title: 'Clase de Servicio',
            icon: null,
            activeSubMenu: true,
            // roles: [Role.ADM],
            permissions: [
              AccessElements.ServiceClassCreate,
              AccessElements.ServiceClassSearch
            ]
          }
        ]
      },
      /*
      {
        key: 'drawer.admin.catalogues.changeManagement',
        path: '',
        title: 'Administración Cambios',
        icon: <InformativeModuleSVG />,
        roles: [],
        permissions: [
          AccessElements.ChangeAdvisoryBoardCreate,
          AccessElements.ChangeAdvisoryBoardDelete,
          AccessElements.ChangeAdvisoryBoardUpdate,
          AccessElements.ChangeAdvisoryBoardSearch,
          AccessElements.ChangeStageSearchGeneral,
          AccessElements.ChangeStageStatusSearchGeneral,
          AccessElements.ChangeFlowCreate,
          AccessElements.ChangeFlowDelete,
          AccessElements.ChangeFlowSearch,
          AccessElements.ChangeFlowUpdate,
          AccessElements.ChangeTypeCreate,
          AccessElements.ChangeTypeDelete,
          AccessElements.ChangeTypeUpdate,
          AccessElements.ChangeTypeSearch
        ],
        submenu: [
          {
            key: 'admin.changeManagement.changeTypes.drawerName',
            path: `/changeTypes`,
            title: 'Catalogo Tipo de Cambios',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [],
            permissions: [
              AccessElements.ChangeTypeCreate,
              AccessElements.ChangeTypeDelete,
              AccessElements.ChangeTypeUpdate,
              AccessElements.ChangeTypeSearch
            ]
          },
          {
            key: 'admin.changeManagement.statesOfChange.drawerName',
            path: `/statesOfChange`,
            title: 'Catalogo Etapas de Cambios',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [],
            permissions: [AccessElements.ChangeStageSearchGeneral]
          },
          {
            key: 'admin.changeManagement.stagesAndStatuses.drawerName',
            path: `/admin/stagesAndStatuses`,
            title: 'Catalogo Estados y etapas de Cambios',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [],
            permissions: [AccessElements.ChangeStageStatusSearchGeneral]
          },
          {
            key: 'drawer.admin.changeManagement.CABManagement',
            path: `/admin/CABManagement`,
            title: 'Gestión CAB',
            activeSubMenu: true,
            icon: <EngineeringOutlinedIcon />,
            roles: [],
            permissions: [
              AccessElements.ChangeAdvisoryBoardCreate,
              AccessElements.ChangeAdvisoryBoardDelete,
              AccessElements.ChangeAdvisoryBoardUpdate,
              AccessElements.ChangeAdvisoryBoardSearch
            ]
          },
          {
            key: 'drawer.admin.changeManagement.flowOfChanges',
            path: `/admin/flowOfChanges`,
            title: 'Flujo de cambios',
            activeSubMenu: true,
            icon: null,
            roles: [],
            permissions: [
              AccessElements.ChangeFlowCreate,
              AccessElements.ChangeFlowDelete,
              AccessElements.ChangeFlowSearch,
              AccessElements.ChangeFlowUpdate
            ]
          }
        ]
      },
      */
      {
        key: 'drawer.admin.catalogues.ticketConfiguration',
        path: '',
        title: 'Configuración de tickets (criticidad)',
        icon: <InformativeModuleSVG />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.ImpactCreate,
          AccessElements.ImpactSearch,
          AccessElements.UrgencyCreate,
          AccessElements.UrgencySearch,
          AccessElements.TicketPriorityCreate,
          AccessElements.TicketPrioritySearch,
          AccessElements.AssignmentPriorityCreate,
          AccessElements.AssignmentPrioritySearch
        ],
        submenu: [
          {
            key: 'drawer.admin.catalogues.impact',
            path: `/admin/impact`,
            title: 'Impacto',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.ImpactCreate,
              AccessElements.ImpactSearch
            ]
          },
          {
            key: 'drawer.admin.catalogues.priority',
            path: `/admin/priority`,
            title: 'Priority',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.TicketPriorityCreate,
              AccessElements.TicketPrioritySearch
            ]
          },
          {
            key: 'drawer.admin.catalogues.urgency',
            path: `/admin/urgency`,
            title: 'Urgency',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.UrgencyCreate,
              AccessElements.UrgencySearch
            ]
          },
          {
            key: 'drawer.admin.catalogues.criticality',
            path: `/admin/create/criticality`,
            title: 'Criticidad para el tickets',
            activeSubMenu: true,
            icon: <PaidIcon />,
            roles: [Role.ADM],
            permissions: [
              AccessElements.AssignmentPriorityCreate,
              AccessElements.AssignmentPrioritySearch
            ]
          }
        ]
      },
      {
        key: 'drawer.admin.clientsManagement',
        path: `/admin/clientsManagment`,
        title: 'Configuración Cliente (Tecnología)',
        icon: <ManageAccountsSharpIcon />,
        roles: [Role.ADM],
        permissions: [
          AccessElements.ClientSearchGeneral,
          AccessElements.ClientCreate,
          AccessElements.ClientUpdate,
          AccessElements.ClientDelete,
          AccessElements.ClientAddState,
          AccessElements.ClientEnableService,
          AccessElements.FlowTypeAdd,
          AccessElements.FlowTypeDelete,
          AccessElements.FlowTypeSearch,
          AccessElements.FlowTypeUpdate,
          AccessElements.ClientCreateODT,
          AccessElements.ClientUpdateODT,
          AccessElements.ClientDeleteODT,
          AccessElements.ClientSearchExportODT,
          AccessElements.ServiceCreate,
          AccessElements.ServiceSearchGeneral,
          AccessElements.ServiceUpdate,
          AccessElements.ServiceDelete,
          AccessElements.ServiceConfiguration
        ]
      },
      {
        key: 'drawer.admin.audit',
        path: `/admin/audit`,
        title: 'Auditorías',
        icon: <ManageAccountsSharpIcon />,
        permissions: [
          AccessElements.AuditCreate,
          AccessElements.AuditCreateReport,
          AccessElements.AuditReportSearchGeneral,
          AccessElements.AuditSearchGeneral
        ]
      }
      // {
      //   key: 'drawer.admin.escalations',
      //   path: `/admin/Escalations `,
      //   title: 'Escalamientos',
      //   icon: <ManageAccountsSharpIcon />,
      //   roles: [Role.ADM],
      //   permissions: [
      //     AccessElements.EscalationCreate,
      //     AccessElements.EscalationDelete,
      //     AccessElements.EscalationSearch,
      //     AccessElements.EscalationUpdate,
      //     AccessElements.EscalationGet,
      //     AccessElements.EscalationTypeGet
      //   ]
      // }
    ]
  },
  // SE COMENTO EL 05/03/2025 POR INDICACIONES DE DANI
  // UNICAMENTE EN STAGING TIENE QUE ESTAR COMENTADO
  // DEV Y QA QUEDA IGUAL
  // {
  //   key: 'drawer.chatbot',
  //   path: ``,
  //   title: 'Chatbot',
  //   icon: <ScienceIcon />,
  //   roles: [],
  //   permissions: [],
  //   submenu: [
  //     {
  //       key: 'drawer.chatbot',
  //       path: `/chatbot`,
  //       title: 'Chatbot',
  //       activeSubMenu: true,
  //       icon: <GridViewIcon />,
  //       permissions: []
  //     }
  //   ]
  // },
  {
    key: 'drawer.informativeModule.informativeModuleTitle',
    path: `/`,
    title: 'Módulo informativo',
    icon: <InformativeModuleSVG />,
    roles: [],
    permissions: [],
    submenu: [
      {
        key: 'drawer.informativeModule.asignedClients',
        path: `/informativeModule/clients`,
        title: 'Clientes asignados al usuario',
        icon: <LocalActivityIcon />,
        roles: [],
        permissions: []
      },
      {
        key: 'drawer.informativeModule.asignedWorkForce',
        path: `/informativeModule/workForce`,
        title: 'Fuerzas de trabajo asignadas al usuario',
        icon: <ManageSearchIcon />,
        roles: [],
        permissions: []
      }
    ]
  },
  {
    key: 'drawer.reports.reportsTitle',
    path: '/',
    title: 'Reportes',
    icon: <Assignment />,
    roles: [],
    permissions: [
      AccessElements.GenerateDashboardGeneralSearch,
      AccessElements.DashboardShowReportsDashboars,
      AccessElements.TicketReportGeneralSearch,
      AccessElements.DashboardShowReportsCost,
      AccessElements.DashboardShowReportRemoteWork,
      AccessElements.DashboardOpenIncidents,
      AccessElements.DashboardHistoricalIncidents
    ],
    submenu: [
      {
        key: 'drawer.reports.internal',
        path: `/reports`,
        title: 'Reportes',
        icon: <HelpCenterIcon />,
        roles: [],
        permissions: [
          AccessElements.GenerateDashboardGeneralSearch,
          AccessElements.DashboardShowReportsDashboars
        ]
      },
      {
        key: 'drawer.reports.exportReports',
        path: `/exportTicketsReport`,
        title: 'Exportar Reportes',
        icon: <Assignment />,
        roles: [],
        permissions: [
          AccessElements.TicketReportGeneralSearch,
          AccessElements.DashboardShowReportsDashboars
        ]
      },
      {
        key: 'drawer.reports.expenseReports',
        path: `/expenseReport`,
        title: 'Reporte de costos de servicios',
        icon: <Assignment />,
        roles: [],
        permissions: [AccessElements.DashboardShowReportsCost]
      },
      {
        key: 'drawer.reports.recidivistsReports',
        path: `/recidivists`,
        title: 'Reincidentes',
        icon: <Assignment />,
        roles: [],
        permissions: [AccessElements.DashboardShowReportsDashboars]
      },
      {
        key: 'drawer.reports.mayorIncidentReport',
        path: `/mayorIncident`,
        title: 'Incidentes Mayores',
        icon: <Assignment />,
        roles: [],
        permissions: [AccessElements.DashboardShowReportsDashboars]
      },
      {
        key: 'drawer.reports.remoteWorkReport',
        path: `/remoteWork`,
        title: 'Trabajo Remoto',
        icon: <Assignment />,
        roles: [],
        permissions: [AccessElements.DashboardShowReportRemoteWork]
      },
      {
        key: 'drawer.reports.incidentReport',
        path: '',
        title: 'Reporte de incidentes',
        icon: <DonutLargeIcon />,
        roles: [],
        permissions: [
          AccessElements.DashboardOpenIncidents,
          AccessElements.DashboardHistoricalIncidents,
          AccessElements.DashboardShowReportsDashboars
        ],
        submenu: [
          {
            key: 'drawer.reports.openIncidents',
            path: `/incidentReports/open`,
            title: 'Incidentes abiertos',
            icon: <HelpCenterIcon />,
            roles: [],
            permissions: [AccessElements.DashboardOpenIncidents]
          },
          {
            key: 'drawer.reports.historicalIncidents',
            path: `/incidentReports/historical`,
            title: 'Incidentes históricos',
            icon: <HelpCenterIcon />,
            roles: [],
            permissions: [AccessElements.DashboardHistoricalIncidents]
          }
        ]
      }
    ]
  },
  {
    key: 'drawer.KMDB',
    path: `/`,
    title: 'Base de Datos de Conocimiento',
    icon: <HelpCenterIcon />,
    roles: [],
    permissions: [],
    submenu: [
      {
        key: 'drawer.KMDB',
        path: `/KMDB`,
        title: 'Base de Datos de Conocimiento',
        icon: <HelpCenterIcon />,
        roles: [],
        permissions: []
      }
    ]
  },
  {
    key: 'drawer.surveys.title',
    path: `/`,
    title: 'Encuestas',
    icon: <ChecklistIcon />,
    roles: [],
    permissions: [
      AccessElements.SurveyManagement,
      AccessElements.SurveySearch,
      AccessElements.SurveyReport
    ],
    submenu: [
      {
        key: 'drawer.surveys.new',
        path: `/surveys/new`,
        title: 'Nueva encuesta',
        icon: <ChecklistIcon />,
        roles: [],
        permissions: [AccessElements.SurveyManagement]
      },
      {
        key: 'drawer.surveys.search',
        path: `/surveys/search`,
        title: 'Búsqueda de encuestas',
        icon: <ChecklistIcon />,
        roles: [],
        permissions: [AccessElements.SurveySearch]
      },
      {
        key: 'drawer.surveys.report',
        path: `/surveys/report`,
        title: 'Reporte de encuestas',
        icon: <ChecklistIcon />,
        roles: [],
        permissions: [AccessElements.SurveyReport]
      }
    ]
  },
  /*
  {
    key: 'drawer.problem.drawerTitle',
    path: '',
    title: 'Problemas',
    icon: <ReportProblemIcon />,
    roles: [],
    permissions: [
      AccessElements.ProblemCreate,
      AccessElements.ProblemUpdate,
      AccessElements.ProblemDelete,
      AccessElements.ProblemSearch,
      AccessElements.ProblemAddFile,
      AccessElements.ProblemDeleteFile,
      AccessElements.ProblemQueryFile
    ],
    submenu: [
      {
        key: 'drawer.problem.search',
        path: `/problem/search`,
        title: 'Búsqueda de problemas',
        activeSubMenu: true,
        icon: <PaidIcon />,
        roles: [],
        permissions: [AccessElements.ProblemSearch]
      },
      {
        key: 'drawer.problem.create',
        path: `/problem/create`,
        title: 'Nuevo problema',
        activeSubMenu: true,
        icon: <PaidIcon />,
        roles: [],
        permissions: [AccessElements.ProblemCreate]
      }
    ]
  },
  */
  {
    key: 'drawer.help.helpTitle',
    path: `/`,
    title: 'Ayuda',
    icon: <HelpCenterIcon />,
    roles: [],
    permissions: [],
    submenu: [
      {
        key: 'drawer.help.FAQs',
        path: `/help/FAQs`,
        title: 'FAQs / Preguntas frecuentes',
        icon: <HelpCenterIcon />,
        roles: [],
        permissions: []
      }
    ]
  }
];

export default drawerConfig;
